export default "__VITE_ASSET__BQqNbKQS__"